import { Form } from 'factorial-form'

class TimeoffForm extends Form {
  constructor(values: {}) {
    super(values, {
      timeoff_manager_id: 'number',
      timeoff_policy_id: 'number',
      tenure_start_date: 'date',
    })
  }

  readonly notNullableKeys: string[] = ['timeoff_policy_id']

  // We need to remove null values from the payload.
  // When using policy timeline we are exposing the current policy as timeoff_policy_id
  // instead of the actual timeoff_policy_id stored in the DB (the timeline's initial).
  // This way we avoid updating the DB field (initial) when passing the employee with
  // timeoff_policy_id set to the current's one, in order to keep the DB field untouched.
  get serialized(): Record<string, number | string> {
    return Object.fromEntries(
      Object.entries(this.values).filter(([key, value]) => {
        if (this.notNullableKeys.includes(key)) {
          return !!value
        }

        return true
      })
    )
  }
}

export default TimeoffForm
